import * as React from 'react'
import { forwardRef } from 'react'
import cx from 'classnames'
import { useIntl } from 'react-intl'

import UploaderFile from '../UploaderFile'
import UploaderErrors from '../UploaderErrors'

const UploadInputWithPreview: Uploader.UploadPresentationalComponent = (
  { upload, value, errors, fullWidth, onClick, onChange, onReset, onErrorClose },
  ref
) => {
  const intl = useIntl()
  return (
    <div className={cx('uploader', fullWidth && 'uploader--full')}>
      <div className="uploader-single-file">
        <UploaderFile
          file={value}
          hasError={errors.length > 0}
          onClick={onClick}
          onRemove={onReset}
          changeFileText={intl.formatMessage({ defaultMessage: 'Change File' })}
        />
        <UploaderErrors errors={errors} constraints={upload.getConstraints()} onErrorClose={onErrorClose} />
      </div>

      <input
        ref={ref}
        className="uploader__input"
        type="file"
        onChange={onChange}
        accept={upload.getAllowedMimeTypesAsAcceptAttribute()}
        multiple={upload.isMultiple()}
      />
    </div>
  )
}

export default forwardRef(UploadInputWithPreview)
